import { render, staticRenderFns } from "./CardCurrentStock.vue?vue&type=template&id=2d8013c2&scoped=true"
import script from "./CardCurrentStock.vue?vue&type=script&lang=js"
export * from "./CardCurrentStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8013c2",
  null
  
)

export default component.exports